(function () {
  'use strict';

  var BUILD = '0248315543a0';

  var doc = document;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel));
  }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }
  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) {  }
    return null;
  }
  function money(cents) {
    var n = Math.round(cents) / 100;
    return '¥' + n.toLocaleString('ja-JP', { maximumFractionDigits: 0 });
  }
  function root() { return doc.documentElement; }

  var scrollLock = (function () {
    var depth = 0, at = 0;
    return {
      hold: function () {
        if (depth++ > 0) return;
        at = window.pageYOffset || root().scrollTop || 0;
        doc.body.style.top = (-at) + 'px';
        root().classList.add('ns-locked');
      },
      release: function () {
        if (depth === 0) return;
        if (--depth > 0) return;
        root().classList.remove('ns-locked');
        doc.body.style.top = '';
        window.scrollTo(0, at);
      },

      reset: function () {
        depth = 0; at = 0;
        root().classList.remove('ns-locked');
        doc.body.style.top = '';
      },
      held: function () { return depth > 0; }
    };
  })();

  function imgOf(x) {
    if (!x) return '';
    return typeof x === 'string' ? x : (x.url || x.src || '');
  }

  function thumb(url, size) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url;
    return String(url).replace(/(\.[a-z]+)(\?|$)/i, '_' + size + '$1$2');
  }

  var sfx = (function () {
    var ctx = null, armed = false;
    var ON_KEY = 'ns:sfx';

    function enabled() { return store(ON_KEY) !== '0'; }
    function ac() {
      if (!ctx) {
        var C = window.AudioContext || window.webkitAudioContext;
        if (!C) return null;
        ctx = new C();
      }

      if (ctx.state === 'suspended') { try { ctx.resume(); } catch (e) {} }
      return ctx;
    }

    function tone(freq, dur, delay, vol, type) {
      var a = ac(); if (!a) return;
      var t = a.currentTime + (delay || 0);
      var o = a.createOscillator(), g = a.createGain();
      o.type = type || 'square';
      o.frequency.setValueAtTime(freq, t);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol || 0.05, t + 0.008);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g); g.connect(a.destination);
      o.start(t); o.stop(t + dur + 0.02);
    }
    return {

      arm: function () { if (!armed) { armed = true; ac(); } },

      armFromStart: function () {
        if (store(ON_KEY) === null) { store(ON_KEY, '1'); }
        this.arm();
      },
      enabled: enabled,
      toggle: function () {
        var next = enabled() ? '0' : '1';
        store(ON_KEY, next);
        if (next === '1') { this.arm(); this.ok(); }
        return next === '1';
      },

      tick: function () {
        if (!enabled()) return;
        tone(1568, 0.06, 0, 0.11); tone(2093, 0.09, 0.05, 0.10);
      },
      ok: function () {
        if (!enabled()) return;
        tone(660, 0.07, 0, 0.09); tone(990, 0.1, 0.06, 0.08);
      },

      start: function () {
        if (!enabled()) return;
        var a = ac(); if (!a) return;
        var room = a.createDelay(1.0); room.delayTime.value = 0.16;
        var fb = a.createGain(); fb.gain.value = 0.28;
        var wet = a.createGain(); wet.gain.value = 0.3;
        var lp = a.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 4200;
        room.connect(lp); lp.connect(fb); fb.connect(room); lp.connect(wet); wet.connect(a.destination);
        var t0 = a.currentTime;
        function note(f, d, at, v, type, atk) {
          var t = t0 + at, o = a.createOscillator(), g = a.createGain();
          o.type = type; o.frequency.setValueAtTime(f, t);
          g.gain.setValueAtTime(0.0001, t);
          g.gain.exponentialRampToValueAtTime(v, t + atk);
          g.gain.exponentialRampToValueAtTime(0.0001, t + d);
          o.connect(g); g.connect(a.destination); g.connect(room);
          o.start(t); o.stop(t + d + 0.05);
        }
        note(1319, 0.14, 0, 0.11, 'square', 0.008);
        note(1760, 0.14, 0.07, 0.11, 'square', 0.008);
        note(2217, 0.14, 0.14, 0.11, 'square', 0.008);

        note(3520, 0.4, 0.24, 0.06, 'sine', 0.004);
        note(7040, 0.28, 0.245, 0.021, 'sine', 0.004);
        var len = Math.floor(a.sampleRate * 0.02), buf = a.createBuffer(1, len, a.sampleRate), ch = buf.getChannelData(0);
        for (var i = 0; i < len; i++) ch[i] = (Math.random() * 2 - 1) * (1 - i / len);
        var src = a.createBufferSource(), hp = a.createBiquadFilter(), ng = a.createGain();
        src.buffer = buf; hp.type = 'highpass'; hp.frequency.value = 8000; ng.gain.value = 0.054;
        src.connect(hp); hp.connect(ng); ng.connect(a.destination); ng.connect(room);
        src.start(t0 + 0.24);
      },
      nope: function () { if (enabled()) tone(196, 0.14, 0, 0.08, 'triangle'); },

      back: function () {
        if (!enabled()) return;
        tone(660, 0.05, 0, 0.06); tone(440, 0.07, 0.045, 0.056);
      }
    };
  })();

  function paintSfxBtn(btn) {
    if (!btn) return;
    var on_ = sfx.enabled();
    btn.setAttribute('aria-pressed', on_ ? 'true' : 'false');
    var lbl = btn.querySelector('[data-ns-sfx-label]');
    if (lbl) lbl.textContent = on_ ? 'sound on' : 'sound off';
  }

  function initBoot() {
    var boot = $('[data-ns-boot]');
    if (!boot) return;

    var SEEN = 'ns:booted';
    var once = boot.getAttribute('data-once') === 'true';
    var seen = null;
    try { seen = window.sessionStorage.getItem(SEEN); } catch (e) {}
    if (once && seen === '1') { boot.remove(); return; }

    var name = $('[data-ns-bootname]', boot);
    if (name) {
      var word = name.textContent.trim();
      name.textContent = '';
      word.split('').forEach(function (ch, i) {
        var s = doc.createElement('span');
        s.textContent = ch;
        s.style.animationDelay = (0.28 + i * 0.045) + 's';
        name.appendChild(s);
      });
    }

    function trap(e) {
      if (e.key !== 'Tab') return;
      var f = $$('button, [href]', boot);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    var done = false;
    function enter(byHand) {
      if (done) return;
      done = true;
      if (byHand === true) { sfx.armFromStart(); sfx.start(); }
      $$('[data-ns-sfx]').forEach(paintSfxBtn);
      boot.classList.add('is-flash');
      window.setTimeout(function () { boot.classList.add('is-cleared'); }, 200);
      scrollLock.release();
      try { window.sessionStorage.setItem(SEEN, '1'); } catch (e) {}
      doc.removeEventListener('keydown', trap, true);
      window.setTimeout(function () { boot.remove(); }, 950);
      doc.dispatchEvent(new CustomEvent('ns:booted'));
    }

    scrollLock.hold();
    doc.addEventListener('keydown', trap, true);

    if (window.NSBGM && window.NSBGM.takeBoot && window.NSBGM.takeBoot({ boot: boot, enter: enter, sfx: sfx })) {
      var btn0 = $('[data-ns-start]', boot);
      if (btn0) window.setTimeout(function () { try { btn0.focus(); } catch (e) {} }, 60);
      return;
    }
    on($('[data-ns-start]', boot), 'click', function () { enter(true); });
    on(boot, 'click', function (e) { if (e.target === boot) enter(true); });
    on(doc, 'keydown', function (e) {
      if (!boot.isConnected) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') { e.preventDefault(); enter(true); }
    });

    var btn = $('[data-ns-start]', boot);
    if (btn) window.setTimeout(function () { try { btn.focus(); } catch (e) {} }, 60);
  }

  var bagState = null;

  function paintCount(n) {
    $$('[data-ns-count]').forEach(function (el) {
      el.textContent = n;
      el.style.visibility = n > 0 ? '' : 'hidden';
    });
  }

  function isCart(c) {
    return !!c && typeof c.item_count === 'number' && Array.isArray(c.items);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function (c) {
        if (!isCart(c)) throw new Error('not a cart');
        return c;
      });
  }

  function cartRefusal(data) {
    if (!data) return null;
    var d = data.description || data.message;
    return typeof d === 'string' && d ? d : null;
  }

  function refusalLine(said) {
    if (!said) return 'その数はご用意がありません';
    if (/[^\x00-\x7F]/.test(said)) return said;
    var n = said.match(/(\d+)/);
    return n ? 'ご用意できるのは' + n[1] + '点までです' : 'その数はご用意がありません';
  }

  function renderBag(cart) {
    if (!isCart(cart)) return;
    bagState = cart;
    paintCount(cart.item_count);

    var body = $('[data-ns-bag-body]');
    var foot = $('[data-ns-bag-foot]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="ns-drawer__empty"><span>(^_^)&#9734;</span>' +
        'no data<br>the bag is empty</div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    body.innerHTML = cart.items.map(function (li, i) {
      var opts = (li.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.value; }).join(' / ');
      var img = li.image
        ? '<img src="' + thumb(li.image, '160x') +
          '" alt="" width="58" height="58" loading="lazy">'
        : '';
      return '' +
        '<div class="ns-line" data-ns-line="' + (i + 1) + '">' +
          '<a class="ns-line__img" href="' + li.url + '">' + img + '</a>' +
          '<div class="ns-line__info">' +
            '<a class="ns-line__name" href="' + li.url + '">' + li.product_title + '</a>' +
            (opts ? '<div class="ns-line__opt">' + opts + '</div>' : '') +
            '<div class="ns-line__price">' + money(li.final_line_price) + '</div>' +
            '<div class="ns-step">' +
              '<button type="button" data-ns-qty="-1" aria-label="one less">&#8722;</button>' +
              '<output>' + li.quantity + '</output>' +
              '<button type="button" data-ns-qty="1" aria-label="one more">+</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    var sub = $('[data-ns-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);

    paintNudge(cart);

    var meter = $('[data-ns-meter]');
    if (meter) {
      var goal = parseInt(meter.getAttribute('data-goal') || '0', 10);
      if (goal > 0) {
        var left = goal - cart.total_price;
        var pct = Math.min(100, (cart.total_price / goal) * 100);
        $('[data-ns-meter-fill]', meter).style.width = pct + '%';
        $('[data-ns-meter-txt]', meter).textContent = left > 0

          ? 'あと ' + money(left) + ' で送料無料'
          : '送料無料になりました';
        meter.classList.toggle('is-free', left <= 0);
      }
    }
  }

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) {
        return r.json()
          .catch(function () { return null; })
          .then(function (data) {
            if (r.ok && isCart(data)) return data;
            var e = new Error('change ' + r.status);
            e.said = cartRefusal(data);
            throw e;
          });
      })
      .then(renderBag)
      .catch(function (e) {
        sfx.nope();
        toast(refusalLine(e && e.said));

        return fetchCart().then(renderBag).catch(function () {});
      });
  }

  var bagOpener = null;

  function bagFocusables(d) {
    return $$('a[href], button:not([disabled]), input, select, textarea', d)
      .filter(function (el) {
        if (el.hidden || el.closest('[hidden]')) return false;
        var r = el.getBoundingClientRect();
        if (r.width < 1 || r.height < 1) return false;
        var s = window.getComputedStyle(el);
        return s.display !== 'none' && s.visibility !== 'hidden';
      });
  }

  function trapIn(panel) {
    return function (e) {
      if (e.key !== 'Tab' || !panel || !panel.isConnected) return;

      if (panel.hidden || !panel.getBoundingClientRect().height) return;
      var f = bagFocusables(panel);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];

      if (!panel.contains(doc.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    };
  }

  function trapBag(e) {
    var d = $('[data-ns-bag]');
    if (!d || !d.classList.contains('is-open')) return;
    trapIn(d)(e);
  }

  function bagUnreachable() {
    var body = $('[data-ns-bag-body]');
    if (!body || $('[data-ns-line]')) return;
    body.innerHTML =
      '<div class="ns-drawer__empty"><span>( &#183;_&#183; )</span>' +
      'いまバッグを読み込めませんでした<br>' +
      '<a class="ns-empty__back" href="/cart" data-no-swap>カートを開く</a></div>';
    var foot = $('[data-ns-bag-foot]');
    if (foot) foot.hidden = true;
  }

  function readBag() {
    return fetchCart().then(renderBag).catch(bagUnreachable);
  }

  function openBag(opener) {
    var d = $('[data-ns-bag]');
    if (!d) return;
    if (d.classList.contains('is-open')) { readBag(); return; }
    bagOpener = opener || doc.activeElement;
    d.classList.add('is-open');
    scrollLock.hold();
    doc.addEventListener('keydown', trapBag, true);
    readBag();
    var c = $('[data-ns-bag-close]', d);
    if (c) window.setTimeout(function () { try { c.focus(); } catch (e) {} }, 80);
  }

  function closeBag() {
    var d = $('[data-ns-bag]');
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    sfx.back();
    scrollLock.release();
    doc.removeEventListener('keydown', trapBag, true);
    if (bagOpener && bagOpener.isConnected) {
      try { bagOpener.focus(); } catch (e) {}
    }
    bagOpener = null;
  }

  function initBag() {
    var d = $('[data-ns-bag]');
    if (!d) return;

    on(doc, 'click', function (e) {
      var open = e.target.closest('[data-ns-bag-open], a[href$="/cart"], a[href*="/cart?"]');
      if (open) { e.preventDefault(); sfx.tick(); openBag(open); return; }
      if (e.target.closest('[data-ns-bag-close], [data-ns-bag-veil]')) { closeBag(); return; }

      var step = e.target.closest('[data-ns-qty]');
      if (step) {
        var row = step.closest('[data-ns-line]');
        if (!row || !bagState) return;
        var idx = parseInt(row.getAttribute('data-ns-line'), 10);
        var item = bagState.items[idx - 1];
        if (!item) return;
        var next = Math.max(0, item.quantity + parseInt(step.getAttribute('data-ns-qty'), 10));
        sfx.tick();

        var out = $('output', row);
        if (out) out.textContent = next;
        row.classList.add('is-busy');
        changeLine(idx, next);
      }
    });

    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape' && d.classList.contains('is-open')) closeBag();
    });

    fetchCart().then(function (c) { paintCount(c.item_count); }).catch(function () {});
  }

  function productParts() {
    var form = $('[data-ns-form]');
    if (!form) return null;
    var data = $('[data-ns-variants]', form) || $('[data-ns-variants]');
    if (!data) return null;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return null; }
    return {
      form: form,
      variants: variants,
      idField: $('[data-ns-vid]', form),
      buy: $('[data-ns-buy]', form),
      priceEl: $('[data-ns-price]')
    };
  }

  function matchVariant(p) {
    var want = $$('[data-ns-opt]', p.form).map(function (grp) {
      var active = $('.ns-chip__input:checked', grp);
      return active ? active.value : null;
    });
    if (!want.length) return p.variants[0];
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var j = 0; j < want.length; j++) {
        if (want[j] !== null && v.options[j] !== want[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function paintProduct() {
    var p = productParts();
    if (!p || !p.buy) return;
    var label = p.buy.querySelector('[data-ns-buy-label]');
    var v = matchVariant(p);
    if (!v) {
      p.buy.disabled = true;
      if (label) label.textContent = 'unavailable';
      return;
    }
    if (p.idField) p.idField.value = v.id;
    if (p.priceEl) p.priceEl.textContent = money(v.price);

    if (v.image) {
      var url = String(v.image).replace(/&amp;/g, '&');
      var big = $('[data-ns-main-img]');
      if (big && big.src !== url) {
        big.src = url;
        big.removeAttribute('srcset');
        $$('[data-ns-thumb]').forEach(function (t, i) {
          var hit = t.getAttribute('data-full') === url;
          t.setAttribute('aria-current', hit ? 'true' : 'false');
          if (hit) {
            var n = $('[data-ns-shot-no]');
            if (n) n.textContent = (i + 1) + '/' + $$('[data-ns-thumb]').length;
          }
        });
      }
    }

    p.buy.disabled = !v.available;
    if (label) label.textContent = v.available ? 'add to bag' : 'sold out';

    var low = $('[data-ns-low]');
    if (low) {
      var mark = parseInt(low.getAttribute('data-low') || '0', 10);
      var n = typeof v.inv === 'number' ? v.inv : 0;
      if (mark > 0 && v.available && n > 0 && n <= mark) {
        var out = $('[data-ns-low-n]', low);
        if (out) out.textContent = n;
        low.hidden = false;
      } else {
        low.hidden = true;
      }
    }

    var dockBuy = $('[data-ns-dock-buy]');
    if (dockBuy) {
      dockBuy.disabled = !v.available;
      var dl = $('[data-ns-dock-label]');
      if (dl) dl.textContent = v.available ? 'add to bag' : 'sold out';
      var dp = $('[data-ns-dock-price]');
      if (dp) dp.textContent = money(v.price);
    }
  }

  function bindProductOnce() {

    on(doc, 'change', function (e) {
      if (!e.target.classList || !e.target.classList.contains('ns-chip__input')) return;
      sfx.tick();
      paintProduct();
    });

    on(doc, 'submit', function (e) {
      var form = e.target.closest('[data-ns-form]');
      if (!form) return;
      e.preventDefault();

      var p = productParts();

      if (!p || !p.buy) { form.submit(); return; }
      var v = matchVariant(p);
      if (!v || !v.available) { sfx.nope(); return; }

      p.buy.classList.add('is-busy');
      p.buy.disabled = true;

      var added = false;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          added = true;
          sfx.ok();
          buzz(12);
          toast('added to bag (^_-)-\u2606');
          return readBag();
        })
        .then(function () {
          openBag(p.buy);
          p.buy.classList.remove('is-busy');
          p.buy.disabled = false;
          paintProduct();
        })
        .catch(function () {
          p.buy.classList.remove('is-busy');
          if (added) {

            p.buy.disabled = false;
            paintProduct();
            openBag(p.buy);
            return;
          }

          sfx.nope();
          form.submit();
        });
    });
  }

  var dockPending = false;
  function dockFrame() {
    dockPending = false;

    var dock = $('[data-ns-dock]');
    var buy = $('[data-ns-buy]');
    if (!dock || !buy) { root().classList.remove('ns-docked'); return; }
    var up = buy.getBoundingClientRect().bottom < 0;
    dock.classList.toggle('is-up', up);

    root().classList.toggle('ns-docked', up);
  }

  function bindDockOnce() {
    on(window, 'scroll', function () {
      if (dockPending) return;
      dockPending = true;
      window.requestAnimationFrame(dockFrame);
    }, { passive: true });
    on(window, 'resize', dockFrame);
  }

  function initDock() {
    var dock = $('[data-ns-dock]');
    if (dock) dock.hidden = false;
    dockFrame();
  }

  function warmGallery() {
    var main = $('[data-ns-main-img]');
    var t = $$('[data-ns-thumb]');
    if (!main || t.length < 2) return;
    var sizes = main.getAttribute('sizes') || '100vw';
    function go() {
      t.forEach(function (b) {
        var im = new Image();
        im.decoding = 'async';
        im.sizes = sizes;
        var set = b.getAttribute('data-srcset');
        if (set) im.srcset = set;
        im.src = b.getAttribute('data-full');
      });
    }
    if (window.requestIdleCallback) { window.requestIdleCallback(go, { timeout: 1200 }); }
    else { window.setTimeout(go, 400); }
  }

  function initProduct() { paintProduct(); initDock(); warmGallery(); }

  function initGallery() {
    function shots() { return $$('[data-ns-thumb]'); }

    function current() {
      var t = shots();
      for (var i = 0; i < t.length; i++) {
        if (t[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function show(i, quiet) {
      var t = shots();
      if (!t.length) return;
      if (i < 0) { i = t.length - 1; }
      if (i >= t.length) { i = 0; }
      var main = $('[data-ns-main-img]');
      if (!main) return;

      var set = t[i].getAttribute('data-srcset');
      if (set) { main.setAttribute('srcset', set); } else { main.removeAttribute('srcset'); }
      main.src = t[i].getAttribute('data-full');
      main.alt = t[i].getAttribute('data-alt') || '';
      t.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
      t[i].setAttribute('aria-current', 'true');
      try { t[i].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
      var n = $('[data-ns-shot-no]');
      if (n) n.textContent = (i + 1) + '/' + t.length;
      if (!quiet) sfx.tick();
    }

    on(doc, 'click', function (e) {
      var t = e.target.closest('[data-ns-thumb]');
      if (t) { e.preventDefault(); show(shots().indexOf(t)); return; }
      var step = e.target.closest('[data-ns-shot-step]');
      if (step) {
        e.preventDefault();
        show(current() + (step.getAttribute('data-ns-shot-step') === 'next' ? 1 : -1));
      }
    });

    var x0 = null, y0 = null, swiped = false;

    on(doc, 'touchstart', function (e) {
      if (!e.target.closest('.ns-gallery__stage') || shots().length < 2) { x0 = null; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      swiped = false;
    }, { passive: true });

    on(doc, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      swiped = true;
      buzz(6);
      show(current() + (dx < 0 ? 1 : -1));
      window.setTimeout(function () { swiped = false; }, 400);
    }, { passive: true });

    on(doc, 'touchcancel', function () { x0 = null; swiped = false; }, { passive: true });

    on(doc, 'click', function (e) {
      if (!swiped || !e.target.closest('.ns-gallery__stage')) return;
      e.preventDefault();
      e.stopPropagation();
      swiped = false;
    }, true);

    on(doc, 'keydown', function (e) {
      if (!doc.activeElement || !doc.activeElement.closest) return;
      if (!doc.activeElement.closest('.ns-gallery')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current() + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current() - 1); }
    });
  }

  function initNav() {
    if (!window.history || !history.pushState || !window.fetch || !window.DOMParser) return;
    var MAIN = '[data-ns-main]';
    if (!$(MAIN)) return;

    var SKIP = /^\/(checkout|cart\/|account|apps\/|admin|tools\/)/;

    function samePage(url) {
      return url.pathname === location.pathname && url.search === location.search;
    }

    var navSeq = 0;
    function swap(url, push) {
      var my = ++navSeq;

      closeFind();
      closeBag();
      closeZoom();
      scrollLock.reset();
      root().classList.add('ns-swapping');
      return fetch(url.href, { headers: { 'X-Requested-With': 'ns-nav' }, credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('bad status');
          return r.text();
        })
        .then(function (html) {
          if (my !== navSeq) return;
          var next = new DOMParser().parseFromString(html, 'text/html');
          var incoming = next.querySelector(MAIN);
          var current = $(MAIN);
          if (!incoming || !current) throw new Error('no main');

          current.innerHTML = incoming.innerHTML;
          doc.title = next.title;
          swapBar(next);

          copyHead(next, 'link[rel="canonical"]', 'href');
          copyHead(next, 'meta[name="description"]', 'content');
          copyHead(next, 'meta[property="og:title"]', 'content');
          copyHead(next, 'meta[property="og:url"]', 'content');
          copyHead(next, 'meta[property="og:image"]', 'content');
          copyHead(next, 'meta[property="og:type"]', 'content');

          var nf = next.querySelector('[data-ns-help-facts]');
          var cf = $('[data-ns-help-facts]');
          if (nf && cf && nf.textContent !== cf.textContent) {
            cf.textContent = nf.textContent;
            readHelpFacts();
            resetHelp();
          }

          if (push && url.href !== location.href) history.pushState({ ns: 1 }, '', url.href);
          window.scrollTo(0, 0);

          initPage();
          doc.dispatchEvent(new CustomEvent('ns:swapped'));
        })
        .catch(function () { if (my === navSeq) location.href = url.href; })
        .finally(function () { if (my === navSeq) root().classList.remove('ns-swapping'); });
    }

    function swapBar(next) {
      var nb = next.querySelector('.ns-bar');
      var cb = $('.ns-bar');
      if (!nb || !cb) return;
      var sheet = nb.querySelector('[data-ns-find-sheet]');
      if (sheet) sheet.parentNode.removeChild(sheet);
      cb.parentNode.replaceChild(doc.importNode(nb, true), cb);
    }

    function copyHead(next, sel, attr) {
      var from = next.querySelector(sel);
      var to = doc.head.querySelector(sel);
      if (from && to) to.setAttribute(attr, from.getAttribute(attr) || '');
    }

    on(doc, 'click', function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var back = e.target.closest('[data-ns-back]');
      if (back) {
        var cameFromHere = false;
        try { cameFromHere = doc.referrer.indexOf(location.origin) === 0 || history.state && history.state.ns; } catch (err) {}
        if (cameFromHere && history.length > 1) {
          e.preventDefault();
          sfx.back();
          history.back();
          return;
        }
      }
      var a = e.target.closest('a[href]');
      if (!a || a.target || a.hasAttribute('download') || a.hasAttribute('data-no-swap')) return;

      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (SKIP.test(url.pathname)) return;
      if (url.hash && samePage(url)) return;

      e.preventDefault();

      if (a.hasAttribute('data-ns-quiet')) { a.removeAttribute('data-ns-quiet'); }
      else { sfx.tick(); }
      swap(url, true);
    });

    on(window, 'popstate', function () { swap(new URL(location.href), false); });
  }

  function markCurrent() {
    $$('.ns-tab').forEach(function (a) {
      var here = false;
      try { here = new URL(a.href, location.href).pathname === location.pathname; } catch (e) {}
      if (here) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  }

  var toastTimer = null;
  function toast(msg) {
    var t = $('[data-ns-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  function armOnFirstTouch() {
    function once() {
      sfx.arm();
      doc.removeEventListener('pointerdown', once, true);
      doc.removeEventListener('keydown', once, true);
    }
    doc.addEventListener('pointerdown', once, true);
    doc.addEventListener('keydown', once, true);
  }

  function initSfxBtn() {
    $$('[data-ns-sfx]').forEach(function (btn) {
      paintSfxBtn(btn);
      on(btn, 'click', function () {
        sfx.arm();
        sfx.toggle();
        $$('[data-ns-sfx]').forEach(paintSfxBtn);
      });
    });
  }

  var zoomOpener = null;

  var trapZoom = null;
  function closeZoom() {
    var z = $('[data-ns-zoom]');
    if (!z || z.hidden) return;
    z.hidden = true;
    if (trapZoom) { doc.removeEventListener('keydown', trapZoom, true); trapZoom = null; }
    z.scrollTop = 0;
    sfx.back();
    scrollLock.release();
    if (zoomOpener && zoomOpener.isConnected) { try { zoomOpener.focus({ preventScroll: true }); } catch (e) {} }
    zoomOpener = null;
  }

  function bindExtrasOnce() {

    on(doc, 'click', function (e) {
      if (e.target.closest('[data-ns-zoom-open]')) {
        var z = $('[data-ns-zoom]');
        if (!z) return;
        zoomOpener = e.target.closest('[data-ns-zoom-open]');
        z.hidden = false;

        z.setAttribute('role', 'dialog');
        z.setAttribute('aria-modal', 'true');
        if (!z.getAttribute('aria-label')) z.setAttribute('aria-label', '写真');
        trapZoom = trapIn(z);
        doc.addEventListener('keydown', trapZoom, true);
        sfx.tick();
        scrollLock.hold();

        var imgs = $$('img', z);
        var from = 0;
        var cur = $('[data-ns-main-img]');
        if (cur) {
          var want = (cur.currentSrc || cur.src || '').split('?')[0];
          imgs.forEach(function (im, i) {
            if (want && (im.src || '').split('?')[0] === want) from = i;
          });
        }
        imgs.forEach(function (im, i) {
          im.setAttribute('loading', i === from ? 'eager' : 'lazy');
          im.setAttribute('fetchpriority', i === from ? 'high' : 'auto');
        });
        if (imgs[from]) {
          try { imgs[from].scrollIntoView({ block: 'start', behavior: 'auto' }); } catch (err) {}
        }
        window.setTimeout(function () {
          imgs.forEach(function (im) {
            if (!im.complete) im.setAttribute('loading', 'eager');
          });
        }, 250);
        var c = $('[data-ns-zoom-close]', z);
        if (c) { try { c.focus(); } catch (err) {} }
        return;
      }
      if (e.target.closest('[data-ns-zoom-close]')) { closeZoom(); return; }

      if (e.target.matches('[data-ns-zoom]')) { closeZoom(); return; }

      var sh = e.target.closest('[data-ns-share]');
      if (sh) {
        sfx.tick();
        var payload = { title: sh.getAttribute('data-title') || doc.title, url: location.href };
        if (navigator.share) {
          navigator.share(payload).catch(function (err) {

            if (!err || err.name !== 'AbortError') copyLink();
          });
        } else {
          copyLink();
        }
        return;
      }
      if (e.target.closest('[data-ns-copy]')) { sfx.tick(); copyLink(); return; }

      if (e.target.closest('.ns-checkout')) { sfx.tick(); return; }
    });

    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape') closeZoom();
    });
  }

  function initContactPrefill() {
    var body = $('[data-ns-c-body]');
    if (!body || body.value) return;
    var item = null;
    try { item = new URLSearchParams(location.search).get('item'); } catch (err) {}
    if (!item) return;
    var subj = $('[data-ns-c-subject]');
    if (subj && !subj.value) subj.value = 'restock: ' + item;
    body.value = 'please let me know when ' + item + ' is back.\n\nsize:\n';
  }

  function copyLink() {
    var url = location.href;
    function done() { toast('リンクをコピーしました'); }

    var settled = false;
    function once(fn) {
      return function () { if (settled) return; settled = true; fn(); };
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      var giveUp = window.setTimeout(once(fallback), 500);
      navigator.clipboard.writeText(url)
        .then(once(function () { window.clearTimeout(giveUp); done(); }))
        .catch(once(function () { window.clearTimeout(giveUp); fallback(); }));
    } else {
      fallback();
    }
    function fallback() {
      var t = doc.createElement('textarea');
      t.value = url;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      doc.body.appendChild(t);
      t.select();
      var copied = false;
      try { copied = doc.execCommand('copy'); } catch (err) { copied = false; }
      doc.body.removeChild(t);

      if (copied) done(); else toast('リンクをコピーできませんでした');
    }
  }

  var facts = {};

  function readHelpFacts() {
    var el = $('[data-ns-help-facts]');
    if (!el) return false;
    try { facts = JSON.parse(el.textContent); return true; } catch (e) { return false; }
  }

  function initHelp() {
    var box = $('[data-ns-help]');
    if (!box) return;
    if (!readHelpFacts()) return;

    var log = $('[data-ns-help-log]', box);
    var pick = $('[data-ns-help-pick]', box);
    var win = $('[data-ns-help-win]', box);
    var opener = null;

    function say(html, mine) {
      var d = doc.createElement('div');
      d.className = 'ns-help__msg' + (mine ? ' ns-help__msg--me' : '');
      d.innerHTML = html;
      log.appendChild(d);
      log.scrollTop = log.scrollHeight;
    }

    function esc(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function yen(n) { return '¥' + Number(n).toLocaleString('ja-JP'); }

    function specTable() {
      if (!facts.spec) return null;
      var groups = facts.spec.split('■').map(function (g) { return g.trim(); }).filter(Boolean);
      var out = '';
      groups.forEach(function (g) {
        var lines = g.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
        var head = lines.shift();
        if (!lines.length) return;
        if (/shipping/i.test(head)) return;
        out += '<div style="margin-top:8px"><b>' + esc(head) + '</b>';
        if (lines[0].indexOf(' / ') > -1) {
          var hasLabel = /[：:]/.test(lines[0]);
          var sample = hasLabel ? lines[0].split(/[：:]/)[1] : lines[0];
          var cols = sample.split(' / ').map(function (c) { return c.trim().split(' ')[0]; });
          out += '<table><thead><tr>' + (hasLabel ? '<th>size</th>' : '');
          cols.forEach(function (c) { out += '<th>' + esc(c) + '</th>'; });
          out += '</tr></thead><tbody>';
          lines.forEach(function (l) {
            var label = '', rest = l;
            if (hasLabel) {
              var p = l.split(/[：:]/);
              label = p[0].trim(); rest = p.slice(1).join(':');
            }
            out += '<tr>' + (hasLabel ? '<th>' + esc(label) + '</th>' : '');
            rest.trim().split(' / ').forEach(function (cell) {
              var parts = cell.trim().split(' ');
              out += '<td>' + esc(parts[parts.length - 1]) + '</td>';
            });
            out += '</tr>';
          });
          out += '</tbody></table>';
        } else {
          out += '<br>' + lines.map(esc).join('<br>');
        }
        out += '</div>';
      });
      return out || null;
    }

    function here(t) { return '<a href="' + facts.contactUrl + '">' + (t || 'こちら') + '</a>'; }
    var TOPICS = [
      { q: 'いつ届く？', a: function () {
          return esc(facts.ship).replace(/、/g, '、<br>').replace(/。$/, '') +
            '<br><br>発送が済むと' +
            '<br>通知メールが自動で届きます' +
            '<br><br>思ったより遅いときは' +
            '<br>注文番号を添えて' +
            '<br>' + here() + 'から教えてください m(_ _)m'; } },
      { q: '送料は？', a: function () {
          return '国内は全国一律 ' + yen(facts.shipFee) +
            '<br>' + yen(facts.freeFrom) + ' 以上のご購入で' +
            '<br>送料無料です (^_^)&#9734;'; } },
      { q: '支払い方法は？', a: function () {
          return 'お支払いは' +
            '<br>' + esc(facts.pay).split(/\s*[\/／・、]\s*/).join('<br>') +
            '<br>からお選びいただけます' +
            '<br><br>表示価格はすべて税込' +
            '<br>決済手数料はかかりません'; } },
      { q: 'サイズを見たい', a: function () {
          var t = specTable();
          if (!t) return '各商品ページに' +
            '<br>実寸のサイズ表を載せています' +
            '<br>お手持ちの服と比べて' +
            '<br>選んでください (^_^)&#9734;';
          return '「' + esc(facts.productTitle) + '」の実寸です' +
            '<br>お手持ちの服と' +
            '<br>比べてみてください (^_^)&#9734;' + t; } },

      { q: '注文はどこで確認できる？', a: function () {
          return 'ご注文のあとに届く' +
            '<br><b>注文確認メール</b>から' +
            '<br>いつでも状況を見られます' +
            '<br><br>発送が済むと' +
            '<br>発送通知メールが届き' +
            '<br>そこから配送状況を追えます' +
            '<br><br>メールが見当たらないときは' +
            '<br>迷惑メールフォルダを確認のうえ' +
            '<br>' + here() + 'からご連絡ください m(_ _)m'; } },
      { q: '売り切れの再入荷', a: function () {
          return '再入荷が決まったら' +
            '<br>お知らせします (^_^)&#9734;' +
            '<br><br>' + here() + 'から' +
            '<br>ほしい商品名と希望サイズを' +
            '<br>送ってください'; } },
      { q: '返品したい', a: function () {
          return '商品に欠陥がある場合を除き' +
            '<br>お客様都合での返品は' +
            '<br>お受けしていません m(_ _)m' +
            '<br><br>不良品・破損・誤配送のときは' +
            '<br>到着後7日以内にご連絡ください' +
            '<br>送料はこちらで負担します'; } },
      { q: '注文を変えたい / 取り消したい', a: function () {
          return 'ご注文の変更・取り消しは' +
            '<br>状況を確認したうえで' +
            '<br>個別に対応しています' +
            '<br><br>注文番号を添えて' +
            '<br>' + here() + 'から連絡してください' +
            '<br><br>発送前であれば' +
            '<br>対応できることが多いです (^_^)&#9734;'; } },
      { q: 'その他', a: function () {
          return here('お問い合わせ') + 'から送ってください' +
            '<br>通常2営業日以内に返信します (^_^)&#9734;'; } }
    ];

    function paintPicks() {
      pick.innerHTML = '';
      TOPICS.forEach(function (t) {
        if (t.q === 'サイズを見たい' && !facts.spec) return;

        if (t.q === '支払い方法は？' && !facts.pay) return;
        var b = doc.createElement('button');
        b.type = 'button';
        b.className = 'ns-help__q';
        b.textContent = t.q;
        b.addEventListener('click', function () {
          say(esc(t.q), true);
          window.setTimeout(function () { say(t.a(), false); }, 220);
          sfx.tick();
        });
        pick.appendChild(b);
      });
    }

    var started = false;
    function open_() {
      opener = doc.activeElement;
      win.hidden = false;
      if (!started) {
        started = true;
        var hello = 'こんにちは (^_^)&#9734;<br>よくある質問には<br>ここで答えます';
        if (facts.productTitle && facts.available === false) {
          hello += '<br><br>この商品はいま売り切れです<br>再入荷のお知らせもできます';
        }
        say(hello, false);
        paintPicks();
      }
      var c = $('[data-ns-help-close]', box);
      if (c) window.setTimeout(function () { try { c.focus(); } catch (e) {} }, 60);
    }
    function close_() {
      if (win.hidden) return;
      win.hidden = true;
      sfx.back();
      if (opener && opener.isConnected) { try { opener.focus(); } catch (e) {} }
    }

    on($('[data-ns-help-open]', box), 'click', function () { sfx.tick(); open_(); });
    on($('[data-ns-help-close]', box), 'click', close_);
    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape' && !win.hidden) close_();
    });

    resetHelp = function () {
      close_();
      started = false;
      log.innerHTML = '';
      pick.innerHTML = '';
    };
  }

  var resetHelp = function () {};

  var closeFind = function () {};

  var JP_WORDS = {
    'デニム': 'denim', 'ジーンズ': 'denim', 'ジーパン': 'denim', 'パンツ': 'pants',
    'ズボン': 'pants', 'スウェット': 'sweat', 'スエット': 'sweat',
    'tシャツ': 'tee', 'ティーシャツ': 'tee', 'てぃーしゃつ': 'tee', 'シャツ': 'shirt',
    'ロンt': 'long tee', 'ロンティー': 'long tee', 'ながそで': 'long tee', '長袖': 'long tee',
    'ラグラン': 'raglan', 'リュック': 'backpack', 'バックパック': 'backpack',
    'かばん': 'backpack', 'バッグ': 'backpack', 'キャップ': 'cap', '帽子': 'cap',
    'ぼうし': 'cap', 'トップス': 'tops', 'ボトムス': 'bots', 'グッズ': 'goods',

    'ダメージ': 'damage', 'ビジュアル': 'visual', 'トラック': 'track',
    'ジャージ': 'track', 'ロング': 'long tee', 'ティー': 'tee',
    'てぃー': 'tee', 'トラッカー': 'cap',

    'パーカー': 'hoodie', 'ぱーかー': 'hoodie', 'フーディ': 'hoodie', 'フーディー': 'hoodie',
    'ジップ': 'zip hoodie', 'ジップパーカー': 'zip hoodie', 'プルオーバー': 'hoodie',
    'ウォレット': 'wallet chain', 'チェーン': 'wallet chain', '財布': 'wallet chain',
    'タンク': 'tank top', 'メッシュ': 'mesh cap', 'ベルト': 'belt'
  };
  function alsoTry(q) {
    var key = String(q || '').trim().toLowerCase();
    if (!key) return null;
    if (JP_WORDS[key]) return JP_WORDS[key];
    for (var k in JP_WORDS) {
      if (Object.prototype.hasOwnProperty.call(JP_WORDS, k) && key.indexOf(k) > -1) {
        return JP_WORDS[k];
      }
    }
    return null;
  }

  function unitsToCents(v) {
    var n = parseFloat(v);
    return isFinite(n) ? Math.round(n * 100) : 0;
  }

  function suggest(q, limit) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + (limit || 8) +
      '&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (((d.resources || {}).results || {}).products) || []; });
  }

  var allCache = null;
  function everything() {
    if (allCache) return Promise.resolve(allCache);
    return fetch('/collections/all/products.json?limit=250',
                 { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('list ' + r.status);
        return r.json();
      })
      .then(function (d) {
        allCache = (d.products || []).map(function (p) {
          var v = (p.variants || [])[0] || {};
          return {
            title: p.title, url: '/products/' + p.handle,
            price: String(v.price || 0),
            available: (p.variants || []).some(function (x) { return x.available; }),
            featured_image: { url: ((p.images || [])[0] || {}).src || '' },
          };
        });
        return allCache;
      })
      .catch(function () { return []; });
  }

  function ownSearch(q, limit) {
    var key = String(q || '').trim().toLowerCase();
    if (!key) return Promise.resolve([]);
    var alt = (alsoTry(q) || '').toLowerCase();
    return everything().then(function (all) {
      return all.filter(function (p) {
        var t = p.title.toLowerCase();
        return t.indexOf(key) > -1 || (alt && t.indexOf(alt) > -1);
      }).slice(0, limit || 10);
    });
  }

  function suggestSmart(q, limit) {
    return suggest(q, limit).then(function (items) {
      if (items.length) return items;
      var alt = alsoTry(q);
      return alt ? suggest(alt, limit) : items;
    }).then(function (items) {
      return items.length ? items : ownSearch(q, limit);
    }).catch(function () { return ownSearch(q, limit); });
  }

  function initFind() {
    var box = $('[data-ns-find]');
    if (!box) return;
    var sheet = $('[data-ns-find-sheet]', box);
    var input = $('[data-ns-find-input]', box);
    var out = $('[data-ns-find-out]', box);
    var timer = null, opener = null, last = '';
    if (!sheet || !input || !out) return;

    if (sheet.parentElement !== doc.body) doc.body.appendChild(sheet);

    var trapFind = trapIn(sheet);

    on(sheet, 'click', function (e) { if (e.target.closest('a[href]')) close_(true); });
    function open_() {
      if (!sheet.hidden) return;
      opener = doc.activeElement;
      sheet.hidden = false;
      scrollLock.hold();
      doc.addEventListener('keydown', trapFind, true);
      window.setTimeout(function () { try { input.focus(); } catch (e) {} }, 60);
    }
    function close_(keepFocus) {
      if (sheet.hidden) return;
      sheet.hidden = true;
      doc.removeEventListener('keydown', trapFind, true);

      if (!keepFocus) sfx.back();
      scrollLock.release();
      if (!keepFocus && opener && opener.isConnected) { try { opener.focus(); } catch (e) {} }
    }

    closeFind = function () { close_(true); };

    function card(p) {
      var img = imgOf(p.featured_image)
        ? '<img src="' + thumb(imgOf(p.featured_image), '120x') +
          '" alt="" width="52" height="52" loading="lazy">'
        : '<img alt="" width="52" height="52">';
      var price = p.price ? money(unitsToCents(p.price)) : '';
      if (p.available === false) price = 'sold out';
      return '<a class="ns-find__hit" href="' + p.url + '">' + img +
        '<span class="ns-find__t">' + p.title +
        '<br><span class="ns-find__p">' + price + '</span></span></a>';
    }

    function run(q) {
      if (!q) { out.innerHTML = ''; return; }
      suggestSmart(q, 10)
        .then(function (items) {
          if (q !== last) return;
          if (!items.length) {

            out.innerHTML =
              '<div class="ns-find__none">(^_^)&#9734; すぐには見つかりませんでした<br>' +
              '<a class="ns-empty__back" href="/search?q=' + encodeURIComponent(q) +
              '" data-no-swap>「' + q.replace(/</g, '&lt;') + '」で検索する</a></div>';
            return;
          }
          out.innerHTML = items.map(card).join('');
        })
        .catch(function () { out.innerHTML = ''; });
    }

    on(doc, 'click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-ns-find-open]')) return;
      sfx.tick(); open_();
    });

    on($('[data-ns-find-close]', sheet), 'click', function () { close_(); });
    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close_();
    });
    on(input, 'input', function () {
      var q = input.value.trim();
      if (q === last) return;
      last = q;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { run(q); }, 180);
    });
  }

  function blockHTML(p) {
    var gone = p.available === false;

    var img = p.featured_image
      ? '<img class="is-loaded" src="' + thumb(p.featured_image, '420x') +
        '" alt="" width="420" height="420" loading="lazy">'
      : '';
    return '<li class="ns-block' + (gone ? ' is-gone' : '') + '">' +
      '<a class="ns-block__link" href="' + p.url + '">' +
      '<span class="ns-block__art is-ready">' + img +
      (gone ? '<span class="ns-block__flag ns-block__flag--gone">sold out</span>' : '') +
      '</span><span class="ns-block__label"><span class="ns-block__name">' + p.title +
      '</span><span class="ns-block__price">' +
      money(p.price) + '</span></span></a></li>';
  }

  function initRecs() {
    var box = $('[data-ns-recs]');
    if (box) {
      var id = box.getAttribute('data-product');
      fetch('/recommendations/products.json?product_id=' + id + '&limit=4&intent=related',
            { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = d.products || [];
          if (!ps.length) return;
          $('[data-ns-recs-grid]', box).innerHTML = ps.map(function (p) {
            return blockHTML({ url: p.url, title: p.title, price: p.price,
                               available: p.available,
                               featured_image: imgOf(p.featured_image) });
          }).join('');
          box.hidden = false;
        })
        .catch(function () {});
    }
    rememberAndPaintSeen();
  }

  function rememberAndPaintSeen() {
    var KEY = 'ns:seen';
    var here = $('[data-ns-form]') ? location.pathname : null;
    var list = [];
    try { list = JSON.parse(store(KEY) || '[]'); } catch (e) { list = []; }

    if (here) {
      var t = $('.ns-product__title');
      var img = $('[data-ns-main-img]');
      var pr = $('[data-ns-price]');
      if (t) {
        list = list.filter(function (x) { return x.url !== here; });
        list.unshift({ url: here, title: t.textContent.trim(),
                       img: img ? img.getAttribute('src') : '',
                       price: pr ? pr.textContent.trim() : '' });
        list = list.slice(0, 8);
        store(KEY, JSON.stringify(list));
      }
    }

    var box = $('[data-ns-seen]');
    if (!box) return;
    var show = list.filter(function (x) { return x.url !== location.pathname; }).slice(0, 4);
    if (show.length < 2) return;
    $('[data-ns-seen-grid]', box).innerHTML = show.map(function (x) {
      return '<li class="ns-block"><a class="ns-block__link" href="' + x.url + '">' +
        '<span class="ns-block__art is-ready">' +
        (x.img ? '<img class="is-loaded" src="' + x.img + '" alt="" width="420" height="420" loading="lazy">' : '') +
        '</span><span class="ns-block__label"><span class="ns-block__name">' + x.title +
        '</span><span class="ns-block__price">' + x.price + '</span></span></a></li>';
    }).join('');
    box.hidden = false;
  }

  function initShimmer() {
    function settle(img) {
      img.classList.add('is-loaded');
      var art = img.closest('.ns-block__art');
      if (art) art.classList.add('is-ready');
    }
    function watch() {
      $$('.ns-block__art img:not(.ns-block__alt)').forEach(function (img) {
        if (img.classList.contains('is-loaded')) return;

        if (img.complete && img.naturalWidth > 0) { settle(img); return; }
        on(img, 'load', function () { settle(img); });
        on(img, 'error', function () { settle(img); });
      });
    }
    watch();

    window.clearTimeout(initShimmer.t1);
    window.clearTimeout(initShimmer.t2);
    initShimmer.t1 = window.setTimeout(watch, 1200);
    initShimmer.t2 = window.setTimeout(watch, 4000);
    if (!initShimmer.bound) {
      initShimmer.bound = true;
      on(window, 'load', function () { initShimmer(); });

      on(window, 'pageshow', function () { initShimmer(); });
    }
  }

  function buzz(ms) {
    try { if (navigator.vibrate) navigator.vibrate(ms || 8); } catch (e) {}
  }

  function filterState(bar) {
    var size = bar.querySelector('.ns-chip[data-size][aria-pressed="true"]');
    var stock = bar.querySelector('.ns-chip[data-instock]');
    return {
      want: size ? (size.getAttribute('data-size') || '') : '',
      inStockOnly: !!(stock && stock.getAttribute('aria-pressed') === 'true')
    };
  }

  function applyFilter(bar) {
    var s = filterState(bar);
    var label = $('[data-ns-count-label]');
    var narrowed = !!s.want || s.inStockOnly;
    var shown = 0;
    $$('.ns-block').forEach(function (li) {

      if (li.classList.contains('ns-block--empty')) {
        li.classList.toggle('is-hidden', narrowed);
        return;
      }
      var have = li.getAttribute('data-sizes') || '';
      var hit = !s.want || have.split('|').indexOf(s.want) > -1;
      if (hit && s.inStockOnly && li.classList.contains('is-gone')) hit = false;
      li.classList.toggle('is-hidden', !hit);
      if (hit) shown++;
    });
    if (label) label.textContent = shown + ' blocks';
  }

  function trueUpFilter() {
    var chip = $('.ns-chip[data-instock]');
    if (!chip) return;
    var gone = $$('.ns-block.is-gone').length;
    if (!gone) {
      var grp = chip.closest('.ns-filter__grp') || chip;
      grp.setAttribute('hidden', '');
      return;
    }
    var want = gone + '件をかくす';
    if (chip.textContent.trim() !== want) chip.textContent = want;
  }

  function bindFilterOnce() {
    on(doc, 'click', function (e) {
      var b = e.target.closest('[data-ns-filter] .ns-chip');
      if (!b) return;
      var bar = b.closest('[data-ns-filter]');
      if (b.hasAttribute('data-instock')) {
        b.setAttribute('aria-pressed',
          b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      } else {
        $$('.ns-chip[data-size]', bar).forEach(function (c) {
          c.setAttribute('aria-pressed', 'false');
        });
        b.setAttribute('aria-pressed', 'true');
      }
      applyFilter(bar);
      sfx.tick();
      buzz(6);
    });
  }

  function initSearchFallback() {
    var board = $('[data-ns-search-results]');
    if (!board) return;
    var terms = (board.getAttribute('data-terms') || '').trim();
    if (!terms) return;
    var meta = $('[data-ns-search-count]');
    var none = $('[data-ns-search-none]');
    if (board.querySelector('.ns-block')) {

      var alt = alsoTry(terms);
      if (!alt) return;
      var grid = board.querySelector('.ns-grid');
      if (!grid) return;
      grid.style.visibility = 'hidden';
      var shown = false;
      var show = function () { if (shown) return; shown = true; grid.style.visibility = ''; };
      setTimeout(show, 1500);
      ownSearch(alt, 24).then(function (items) {
        var have = {};
        $$('.ns-block__link', grid).forEach(function (a) { have[a.getAttribute('href').split('?')[0]] = 1; });
        var add = items.filter(function (p) { return !have[p.url]; });
        if (!add.length) return;
        grid.insertAdjacentHTML('afterbegin', add.map(function (p) {
          return blockHTML({
            url: p.url, title: p.title, price: unitsToCents(p.price),
            available: p.available,
            featured_image: imgOf(p.featured_image)
          });
        }).join(''));
        if (meta) meta.textContent = $$('.ns-block', grid).length + ' found';
      }).catch(function () {}).then(show);
      return;
    }
    suggestSmart(terms, 24).then(function (items) {
      if (!items.length) return;
      board.innerHTML = '<ul class="ns-grid">' + items.map(function (p) {
        return blockHTML({
          url: p.url, title: p.title, price: unitsToCents(p.price),
          available: p.available,
          featured_image: imgOf(p.featured_image)
        });
      }).join('') + '</ul>';
      if (meta) meta.textContent = items.length + ' found';
      if (none) none.remove();
    }).catch(function () {});
  }

  var nudgeCache = null;
  function paintNudge(cart) {
    var box = $('[data-ns-nudge]');
    if (!box) return;
    var meter = $('[data-ns-meter]');
    var goal = meter ? parseInt(meter.getAttribute('data-goal') || '0', 10) : 0;
    if (!goal || !cart.items.length) { box.hidden = true; return; }
    var left = goal - cart.total_price;
    if (left <= 0) { box.hidden = true; return; }

    var have = {};
    cart.items.forEach(function (i) { have[i.product_id] = 1; });

    function draw(list) {
      var pick = list.filter(function (p) { return p.available && !have[p.id]; }).slice(0, 3);
      if (!pick.length) { box.hidden = true; return; }
      $('[data-ns-nudge-txt]').textContent = '足すなら';
      $('[data-ns-nudge-row]').innerHTML = pick.map(function (p) {
        var img = p.featured_image
          ? '<img src="' + thumb(p.featured_image, '240x') + '" alt="" loading="lazy">' : '';
        return '<li><a class="ns-nudge__i" href="' + p.url + '">' + img +
          '<span class="ns-nudge__p">' + money(p.price) + '</span></a></li>';
      }).join('');
      box.hidden = false;
    }

    if (nudgeCache) { draw(nudgeCache); return; }
    var pid = cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=complementary',
          { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d.products || []).map(function (p) {
          return { id: p.id, url: p.url, price: p.price, available: p.available,
                   featured_image: imgOf(p.featured_image) };
        });
        if (!ps.length) throw new Error('none');
        nudgeCache = ps; draw(ps);
      })
      .catch(function () {

        fetch('/collections/all/products.json?limit=20', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.products || []).map(function (p) {
              var v = (p.variants || [])[0] || {};
              return { id: p.id, url: '/products/' + p.handle,
                       price: unitsToCents(v.price),
                       available: (p.variants || []).some(function (x) { return x.available; }),
                       featured_image: (p.images || [])[0] && p.images[0].src };
            });
            nudgeCache = ps; draw(ps);
          })
          .catch(function () { box.hidden = true; });
      });
  }

  function initHelperTuck() {
    var helper = $('.ns-help');
    if (!helper) return;
    var narrow = window.matchMedia('(max-width: 780px)');
    var last = window.pageYOffset || 0, ticking = false;
    function frame() {
      ticking = false;
      var y = window.pageYOffset || 0;
      if (!narrow.matches || scrollLock.held()) { helper.classList.remove('is-tucked'); last = y; return; }
      var dy = y - last;
      if (Math.abs(dy) < 6) return;
      if (dy > 0 && y > 140) helper.classList.add('is-tucked');
      else if (dy < 0) helper.classList.remove('is-tucked');
      last = y;
    }
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }, { passive: true });
    on(narrow, 'change', function () { helper.classList.remove('is-tucked'); });
  }

  function wakeAlt(link) {
    if (!link) return;
    var alt = link.querySelector('.ns-block__alt');
    if (!alt || alt.getAttribute('src')) return;
    var src = alt.getAttribute('data-src');
    if (!src) return;
    var set = alt.getAttribute('data-srcset');
    if (set) alt.setAttribute('srcset', set);
    alt.setAttribute('src', src);
    if (alt.complete && alt.naturalWidth) alt.classList.add('is-loaded');
    else on(alt, 'load', function () { alt.classList.add('is-loaded'); });
  }

  function bindAltWake() {
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      on(doc, ev, function (e) {
        if (!e.target.closest) return;
        wakeAlt(e.target.closest('.ns-block__link'));
      }, ev === 'touchstart' ? { passive: true, capture: true } : true);
    });
  }

  var turned = null;
  function initBlockTurn() {
    if (window.matchMedia && !window.matchMedia('(hover: none)').matches) return;
    on(doc, 'click', function (e) {
      var link = e.target.closest && e.target.closest('.ns-block__link');
      if (!link) return;
      if (!link.querySelector('.ns-block__alt')) return;
      if (link.classList.contains('is-real')) return;

      if (turned && turned !== link) turned.classList.remove('is-real');
      wakeAlt(link);
      link.classList.add('is-real');
      turned = link;
      sfx.tick();
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      window.setTimeout(function () {
        if (turned !== link) return;
        link.setAttribute('data-ns-quiet', '');
        link.click();
      }, 460);
    }, true);

    on(doc, 'ns:swapped', function () { turned = null; });
  }

  function ready(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  var failed = [];
  function safely(name, fn) {
    try { fn(); }
    catch (e) {
      failed.push(name + ': ' + (e && e.message ? e.message : e));

      var boot = $('[data-ns-boot]');
      if (boot && boot.parentNode) {
        boot.parentNode.removeChild(boot);
        scrollLock.reset();
      }
    }
  }

  var POLICY_EN = { 'shipping-policy': 'shipping', 'refund-policy': 'returns',
    'privacy-policy': 'privacy', 'legal-notice': 'legal notice',
    'terms-of-service': 'terms', 'contact-information': 'contact' };
  function englishPolicyTitle() {
    var m = location.pathname.match(/\/policies\/([a-z-]+)/);
    var h = $('.shopify-policy__title h1');
    if (!m || !h || !POLICY_EN[m[1]]) return;
    h.textContent = POLICY_EN[m[1]];
    doc.title = POLICY_EN[m[1]] + ' – nerdstation';
  }

  function initPage() {
    safely('englishPolicyTitle', englishPolicyTitle);
    safely('initProduct', initProduct);
    safely('initShimmer', initShimmer);
    safely('initRecs', initRecs);
    safely('initContactPrefill', initContactPrefill);
    safely('initSearchFallback', initSearchFallback);
    safely('trueUpFilter', trueUpFilter);
    safely('markCurrent', markCurrent);
  }

  ready(function () {
    [['initBoot', initBoot], ['initBag', initBag], ['bindProductOnce', bindProductOnce],
     ['initGallery', initGallery], ['initNav', initNav],
     ['initSfxBtn', initSfxBtn], ['armOnFirstTouch', armOnFirstTouch], ['bindExtrasOnce', bindExtrasOnce],
     ['bindFilterOnce', bindFilterOnce], ['initHelp', initHelp], ['initFind', initFind],
     ['initHelperTuck', initHelperTuck],
     ['bindAltWake', bindAltWake], ['initBlockTurn', initBlockTurn],
     ['bindDockOnce', bindDockOnce],
     ['initPage', initPage]
    ].forEach(function (pair) { safely(pair[0], pair[1]); });
  });

  on(window, 'pageshow', function (e) {
    if (!e.persisted) return;
    var bag = $('[data-ns-bag]');
    if (bag) bag.classList.remove('is-open');
    ['[data-ns-find-sheet]', '[data-ns-help-win]', '[data-ns-zoom]'].forEach(function (sel) {
      var el = $(sel);
      if (el) el.hidden = true;
    });
    scrollLock.reset();
    $$('.is-busy').forEach(function (b) {
      b.classList.remove('is-busy');
      if ('disabled' in b) b.disabled = false;
    });

    paintProduct();
    fetchCart().then(renderBag).catch(function () {});
  });

  window.NS = { toast: toast, openBag: openBag, sfx: sfx, build: BUILD, failed: failed };
})();
